import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-receipt-lookup-page-not-found',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './receipt-lookup-page-not-found.component.html',
    styleUrl: './receipt-lookup-page-not-found.component.scss',
})
export class ReceiptLookupPageNotFoundComponent {}
